<template>
  <div class="scrollView">
    <img src="../assets/xuexi_jifen_banner.jpg" style="display: block; width: 100%; margin-bottom: 20px">

    <div class="jifen-video-item" @click="opencontent(item)" v-for="item in list">
      <div class="video-item-imgs" :style="{height:video_height+'px'}">
        <img :src="item.thumb" class="video-item-imgs-cover">
        <img src="../assets/list_play.png" class="video-item-icon">
      </div>
      <div class="video-item-title ">
        <div class="text-overflow video-item-title-text">{{item.movie_name}}</div>
      </div>
    </div>




  </div>
</template>
<style scoped>

  body,html{ background-color: #eeeeee
  }
  h1{ padding: 15px; font-size: 20px}
  .jifen-video-item{ margin: 0 15px; margin-bottom: 15px; border-radius: 5px; overflow: hidden; background-color: #fff; box-shadow: #cccccc 0 0 8px}
  .video-item-imgs{ width: 100%; position: relative;border-radius: 5px; overflow: hidden;}
  .video-item-imgs-cover{ width: 100%; height: 100%}
  .video-item-icon{ position: absolute;width: 60px;height: 60px; left: 50%; top: 50%; transform: translate(-50%,-50%)}
  .text-overflow{
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .video-item-title{ padding: 10px; font-size: 14px; line-height: 22px;height: 64px}
  .video-item-title-text{ height: 44px}
  .toplink{opacity: 0}
</style>
<script>
// @ is an alias to /src

import request from "../utils/request";
export default {
  name: 'video_jifen_list',
  data(){
    return {
      video_height:200,
      token:'',
      list:[]
    }
  },
  components: {

  },
  created(){
    this.chenglogin();
    this.getData();

    if(window.innerWidth){
      var h = window.innerWidth;
      if(h>640){
        h = 640
      }
      this.video_height =(h-30)/1.777;
    }
    document.title = ' “学习党的二十大·同心跟党走”省直机关无党派人士研修班。'
  },
  methods:{
    opencontent(item){
      this.$router.push({name: "video_jifen_content", params: {id:item.movie_id}})
    },
    chenglogin(){
      let UserData = localStorage.getItem("setUserData");
      if(!UserData){
        this.$router.push({name: "login"})
      }
      try{
        UserData = JSON.parse(UserData)
        if(!UserData.pc_token){
          this.$router.push({name: "login"})
        }else{
          this.token = UserData.pc_token
        }
      }catch (e) {
        this.$router.push({name: "login"})
      }
    },
    getData(){
      request.jifenvideolist({
        token:this.token
      },(res)=>{
        //530
          if(res && res.code ===200){
            this.list = res.data
          }else if(res.code === 530){
            this.$router.push({name: "login"})
          }else if(res && res.message){
              alert(res.message)
          }
      })
    }
  }
}
</script>
